import React from 'react';
import { Layers } from 'lucide-react';
import styles from './RippleSleeveHero.module.css';

const RippleSleeveHero = ({
  badge,
  scriptTitle,
  mainTitleLines,
  kicker,
  descriptions,
  features,
  imagePrimary,
  imageSecondary,
  stampLabel = 'Triple Layer',
}) => (
  <section className={styles.heroSection}>
    <div className={styles.rippleBg} aria-hidden="true" />

    <div className={styles.inner}>
      <div className={styles.layout}>
        <div className={styles.copyCol}>
          <span className={styles.badge}>{badge}</span>

          <div className={styles.titleBlock}>
            <span className={styles.eyebrow}>{scriptTitle}</span>
            <h1 className={styles.title}>
              {mainTitleLines[0]}{' '}
              <span className={styles.titleAccent}>{mainTitleLines[1]}</span>
            </h1>
          </div>

          {kicker && <p className={styles.kicker}>{kicker}</p>}

          <div className={styles.bodyCopy}>
            {descriptions.slice(0, 2).map((text, index) => (
              <p key={index} className={styles.paragraph}>
                {text}
              </p>
            ))}
          </div>

          {features?.length > 0 && (
            <ul className={styles.featureGrid}>
              {features.map((feature, index) => (
                <li key={index} className={styles.featureTile}>
                  <Layers size={12} aria-hidden="true" />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className={styles.stackCol}>
          <div className={styles.layerStack}>
            <span className={styles.layerPlate} aria-hidden="true" />
            <span className={`${styles.layerPlate} ${styles.layerPlateMid}`} aria-hidden="true" />

            {imagePrimary && (
              <figure className={styles.mainFrame}>
                <img src={imagePrimary.src} alt={imagePrimary.alt} />
              </figure>
            )}

            {imageSecondary && (
              <figure className={styles.accentFrame}>
                <img src={imageSecondary.src} alt={imageSecondary.alt} />
              </figure>
            )}

            {stampLabel && (
              <div className={styles.layerBadge}>
                <Layers size={13} aria-hidden="true" />
                <span>{stampLabel}</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default RippleSleeveHero;
